(ns client-portal.client.reports.list.data
  (:require [client-portal.client.concepts.data :as concepts.d]
            [client-portal.client.router :as cp.router]
            [shared.core.reactive :as re]
            [shared.core.util :as util]))

(def root-path [:reports :list])
(def data-path (conj root-path :data))
(def nav-routes-concept-id-path (conj root-path :nav-routes-concept-id))

(defn nav-list-path [db]
  (conj root-path :nav-list (concepts.d/current-concept-id db)))

(def page-size 30)

(defn build-list-page-path [page]
  (conj data-path page))

(defn current-max-page [db]
  (some->> (get-in db data-path)
           (util/when-not-loading)
           (keys)
           (apply max)))

(defn list-data-has-more? [db]
  (let [list-data (get-in db data-path)
        max-page (current-max-page db)]
    (some->> (get (util/when-not-loading list-data) max-page)
             (util/when-not-loading)
             (count)
             (<= page-size))))

(re/reg-sub :reports/list-data-has-more?- list-data-has-more?)

(defn list-loading? [db]
  (let [list-data (get-in db data-path)]
    (or (util/loading? list-data) (some-> list-data (get 0) (util/loading?)))))

(re/reg-sub :reports/list-loading?- list-loading?)

(defn list-next-page-loading? [db]
  (let [page (current-max-page db)]
    (and (pos? page) (util/loading? (get-in db (build-list-page-path page))))))

(re/reg-sub :reports/list-next-page-loading?- list-next-page-loading?)

(re/reg-sub
  :reports/list-next-page-
  (fn [db]
    (some-> (current-max-page db) (inc))))

(re/reg-event-db
  :reports/reload-list re/middleware
  (fn [db]
    (assoc-in db data-path nil)))

(re/reg-event-fx
  :reports/initialize re/middleware
  (fn [{:keys [db]}]
    {:db (assoc-in db data-path nil)
     :forward-events {:register :reports-initialization-listener
                      :events #{:concepts/select}
                      :dispatch-to [:reports/reload-list]}}))

(re/reg-auth0-loader
  :reports/load-list
  (fn [[[_ {:keys [page]}]] _]
    (build-list-page-path (or page 0)))
  (fn [db [_ {:keys [page]} _]]
    (when-let [concept-id (concepts.d/current-concept-id db)]
      (when (and (not (list-next-page-loading? db))
                 (not (list-loading? db)))
        (let [prev-last-row (some-> (util/when-not-loading (get-in db data-path))
                                    (get (or (dec (or page 0)) 0))
                                    (last))
              before-last-modified-at (:last-modified-at prev-last-row)
              before-public-id (:public-id prev-last-row)]
          {:method :get
           :url "/api/reports"
           :query-params (cond-> {:limit page-size
                                  :concept-id concept-id}
                                 (and before-last-modified-at before-public-id)
                                 (assoc :before-last-modified-at before-last-modified-at
                                        :before-public-id before-public-id))}))))
  :transf #(or (some-> % :body (util/->kebab-case-keywords)) [])
  :error-transf (fn [] []))

(re/reg-sub
  :reports/list-data-
  (fn [db]
    (let [current-list (get-in db data-path)
          cur-page (if (util/loading? current-list) 0 (current-max-page db))]
      (if (nil? current-list)
        (re/dispatch-load [:reports/load-list
                           [nil {:page (or (some-> cur-page (inc)) 0)}]])
        current-list))))

(re/reg-sub
  :reports/list-data-flattened-
  :<- [:reports/list-data-]
  (fn [list-data]
    (some->> (util/when-not-loading list-data)
             (filterv #(not (util/loading? (last %))))
             (mapv last)
             (flatten))))

(re/reg-auth0-loader
  :reports/load-nav-list
  (fn [_ db]
    (nav-list-path db))
  (fn [db]
    (when-let [concept-id (concepts.d/current-concept-id db)]
      {:method :get
       :url "/api/reports/nav"
       :query-params {:concept-id concept-id}}))
  :transf #(or (try
                 (some->> %
                          :body
                          (util/->kebab-case-keywords)
                          (map (fn [r] (update r :navigation-configuration util/json-string->map)))
                          (filter (fn [r] (-> r :navigation-configuration :route))))
                 (catch :default _
                   nil))
               [])
  :error-transf (fn [] [])
  :on-success (fn [db _]
                (re/dispatch [:reports/register-nav-routes])
                db))

(re/reg-event-db
  :reports/reset-nav-routes re/middleware
  (fn [db]
    (when (not= (concepts.d/current-concept-id db)
                (get-in db nav-routes-concept-id-path))
      (re/dispatch [:reports/register-nav-routes])
      (cp.router/reset-routes!))
    db))

(re/reg-event-fx
  :reports/register-nav-routes re/middleware
  (fn [{:keys [db]}]
    (some->> (util/when-not-loading (get-in db (nav-list-path db)))
             (keep (fn [{:keys [navigation-configuration]}]
                     (let [{:keys [route icon-type label]} navigation-configuration]
                       (when (and route icon-type label) route))))
             (cp.router/register-routes!))
    {:db (assoc-in db nav-routes-concept-id-path (concepts.d/current-concept-id db))
     :forward-events {:register :reports-nave-routes-listener
                      :events #{:concepts/select}
                      :dispatch-to [:reports/reset-nav-routes]}}))

(re/reg-auth0-load-sub
  :reports/nav-list-
  (fn [_ db] (nav-list-path db))
  :reports/load-nav-list)
